import axios from 'axios';
import { checkEmpty, getStorage } from './utility';
import { toast } from 'react-toastify';

export const CONFIG = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
  'Cache-Control': 'no-cache',
  uuid: '',
  jjpi: '',
  redoq_csd_staff_id: '',
  staffid: '',
  timezone: 'Europe/London',
};

const handleUnauthorized = (error) => {
  if (error?.response?.status !== 401) return;

  const msg =
    error?.response?.data?.msg ||
    error?.response?.data?.message ||
    'Number of concurrent sessions exceeded. You have been logged out.';

  toast.error(msg);

  try {
    localStorage.clear();
    sessionStorage.clear();
  } catch (e) {}

  setTimeout(() => {
    window.location.reload();
  }, 2000);
};

export const getReq = (url = null, params = null, config = CONFIG) => {
  config.uuid = getStorage('uuid');
  config.jjpi = getStorage('jjpi');
  config.redoq_csd_staff_id = getStorage('staffid');
  config.staffid = getStorage('staffid');

  if (params !== null) {
    return axios
      .get(url, { params })
      .then((res) => res)
      .catch((err) => {
        handleUnauthorized(err);
        return err;
      });
  }

  return axios({
    url: `${url}`,
    method: 'GET',
    headers: config,
    withCredentials: true,
  })
    .then((res) => res)
    .catch((err) => {
      handleUnauthorized(err);
      return err;
    });
};

export const postReq = async (url = null, params = null, config = CONFIG) => {
  const userid = getStorage('userid');
  config.userid = !checkEmpty(userid) ? userid : '';

  try {
        const response = await axios
            .post(url, params, { headers: config });
        return response.data;
    } catch (error) {
        handleUnauthorized(error);
        return error;
    }
};
